import { ValueFormatterFunc } from '@ag-grid-community/core';
import { convertToCurrencyFormatFromCents } from 'deckard-ui/dist/utils/formatters';

const possibleValidTypes = ['string', 'number'];

export const centsBasedCurrencyValueFormatter: ValueFormatterFunc = (
  params
) => {
  if (
    // Javascript funniness when converting the following to a number: null, undefined, true, false, etc.
    !possibleValidTypes.includes(typeof params.value) ||
    // False positive that will convert to the number 0
    params.value === ''
  )
    return '';

  // Expecting the value to be cent-based and fractions of a cent are not a concern
  const castedCentValue = Math.floor(Number(params.value));

  // Strings can come out as NaN
  if (Number.isNaN(castedCentValue)) return '';

  return String(convertToCurrencyFormatFromCents(castedCentValue, false) ?? '');
};
